import React from 'react';
import { func, object } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import _ from 'lodash';
import classNames from 'classnames';
import { Icon, Tag } from '@fiverr-private/fit';
import { s_heart } from '@fiverr-private/fit/icons';
import { I18n } from '@fiverr-private/fiverr_context';
import { OWNER_TYPES } from '../../../../utils/constants';
import { contextConnect } from '../../../Context';
import isEqualResource from '../../../../utils/isEqualResource';
import raiseItemCreateSuccess from '../../../../utils/raiseItemCreateSuccess';
import { createCollectionItem, deleteCollectionItem } from '../../../../actions';
import { handleSubmitError } from '../../../../utils/validations';

import './index.scss';

const MenuItem = ({
    collection,
    resource,
    onCollectionClickedCallback = _.noop,
    createCollectionItem = _.noop,
    deleteCollectionItem = _.noop,
    onUpdateCollections = _.noop
}) => {
    const { id, name, items, ownerType } = collection;
    const item = items.find((item) => isEqualResource(resource, item));
    const isBusiness = ownerType === OWNER_TYPES.BUSINESS;

    const onCollectionClicked = async() => {
        const isCollected = !!item;

        await toggleCollectionItem(isCollected);

        onCollectionClickedCallback({ isCollected, clickedComponent: 'menu' });
    };

    const toggleCollectionItem = async(isCollected) => {
        try {
            if (isCollected) {
                await deleteCollectionItem({ id, itemId: item.id, onUpdateCollections });
            } else {
                await createCollectionItem({ id, resource, onUpdateCollections });

                raiseItemCreateSuccess(name);
            }
        } catch (error) {
            handleSubmitError(error);
        }
    };

    return (
        <li className={classNames('menu-item', { 'business-list': isBusiness })}>
            <button onClick={onCollectionClicked}>
                <div className="item-content tbody-5">
                    <Icon className={classNames('menu-item-icon', { 'active': !!item })}>
                        {s_heart}
                    </Icon>
                    <span className="coll-name">{name}</span>
                </div>
                {isBusiness &&
                <Tag className="team-badge"
                    color={Tag.COLORS.BLUE}>
                    <I18n k="collect_package.team"/>
                </Tag>
                }
            </button>
        </li>
    );
};

MenuItem.propTypes = {
    collection: object,
    resource: object,
    onCollectionClickedCallback: func,
    createCollectionItem: func,
    deleteCollectionItem: func,
    onUpdateCollections: func
};

export { MenuItem };
export default compose(
    connect(null, {
        createCollectionItem,
        deleteCollectionItem
    }),
    contextConnect()
)(MenuItem);
